import { render, staticRenderFns } from "./lastMileList.vue?vue&type=template&id=01cd83ac"
import script from "./lastMileList.vue?vue&type=script&lang=js"
export * from "./lastMileList.vue?vue&type=script&lang=js"
import style0 from "./lastMileList.vue?vue&type=style&index=0&id=01cd83ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports